<template>
  <div class="top">
    <div id="caminho">Você está aqui:
      <a href="/">AC El Salvador</a>
      <template v-if="menuselecionado == 'ccd-home'">
        / <span>Inicial</span>
      </template>
      <template v-else>
        <template v-if="menuselecionado == 'ccd-repositorio'">
          / <a @click="mudarSelecao('ccd-home')">Repositório</a>
          / <span>AC {{ acs[acselecionada].nome }}</span>
        </template>
        <template v-else-if="menuselecionado == 'ccd-repositorio-psc'">
          / <a @click="mudarSelecao('ccd-home')">Repositório</a>
          / <span>PSC {{ pscs[pscselecionado].nome }}</span>
        </template>
        <template v-else>
          / <span>{{ menu[menuselecionado] }}</span>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../main';

export default {
  props: [
    'acselecionada',
    'menuselecionado',
    'pscselecionado'
  ],
  data() {
    return {
      menu: EventBus.menu,
    }
  },
  methods: {
    mudarSelecao( selecao ) {
      EventBus.$emit('mudarSelecao', selecao);
    }
  },
  computed: {
    acs() {
      //console.log('Computed: Breadcrumb acs');
      return EventBus.acs;
    },
    pscs() {
      //console.log('Computed: Breadcrumb pscs');
      return EventBus.pscs;
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Breadcrumb.vue?b12b7b14